import { render, staticRenderFns } from "./TableauIdentities.vue?vue&type=template&id=0f5db4d4&scoped=true&"
import script from "./TableauIdentities.vue?vue&type=script&lang=js&"
export * from "./TableauIdentities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5db4d4",
  null
  
)

export default component.exports